import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import {
    ControlValueAccessor,
    FormControl,
    NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { of, Subject, debounceTime } from "rxjs";
import { concatMap, takeUntil } from "rxjs/operators";

@Component({
    selector: "app-search-input",
    templateUrl: "./search-input.component.html",
    styleUrls: ["./search-input.component.scss"],

    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SearchInputComponent),
            multi: true,
        },
    ],
})
export class SearchInputComponent
    implements ControlValueAccessor, OnDestroy, AfterViewInit
{
    @ViewChild("searchInput") searchInput: ElementRef;

    value: string;
    innerControl: FormControl = new FormControl("");
    destroy$ = new Subject<void>();
    @Output()
    close = new EventEmitter<void>();
    constructor() {}

    ngAfterViewInit(): void {
        this.searchInput.nativeElement.focus();
    }

    ngOnInit(): void {
        this.innerControl.valueChanges
            .pipe(
                takeUntil(this.destroy$),
                debounceTime(500),
                concatMap(() => {
                    this.propagateChange(this.innerControl.value);
                    return of();
                })
            )
            .subscribe();
    }
    writeValue(value: any) {
        this.value = value;
    }
    propagateChange = (_: any) => {};

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
    ngOnDestroy(): void {
        this.destroy$.next();
    }
    resetSearch() {
        this.innerControl.setValue("");
    }
}
